export default "__VITE_ASSET__CmBZ44E5__"